import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, ElementRef, EventEmitter, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppSnackBarService } from 'app/shared/services/snackBar.service';
@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss']
})
export class QuestionComponent implements OnInit {

  public questionFormat: any = [
    {
      required: true,
      multipleAnswer: true,
      addOption: true,
      uploadFile: true,
      delete: true,
      swapquestion: true,
      type: 'choice'

    },
    {
      required: true,
      multipleAnswer: true,
      addOption: true,
      uploadFile: true,
      delete: true,
      swapquestion: true,
      type: 'text'

    },
    {
      required: true,
      multipleAnswer: true,
      addOption: true,
      uploadFile: true,
      delete: true,
      swapquestion: true,
      type: 'rating'

    },
    {
      required: true,
      multipleAnswer: true,
      addOption: true,
      uploadFile: true,
      delete: true,
      swapquestion: true,
      type: 'netPromoterScore'

    }];
  public addQuestion: boolean = false;
  public questionForm: any = FormGroup;
  @Output() createdQuestion = new EventEmitter();
  @ViewChildren('file') fileUpload: QueryList<ElementRef>;
  public uploadedFiles: any[] = [];
  public savedFiles: string[] = [];
  public questionDetails: any;
  @ViewChild('clickId') fileInput: ElementRef;

  constructor(public fb: FormBuilder, private appSnackBarService: AppSnackBarService,
    ) { }

  ngOnInit(): void {
    //Form group contain general details and question type form array
    this.questionForm = this.fb.group({
      questions: this.fb.array([])
    })
  }

  questionGroupForm(type?: string) {
    return this.fb.group({
      questionTitle: ["", [Validators.required, this.appSnackBarService.noWhitespaceValidator]],
      questionType: [type ? type : ""],
      isRequired: [false],
      isMultiple: [false],
      isFileUpload: [''],
      options: (type == 'choice' && this.questionDetails == undefined) ? this.fb.array([this.initializeOptions()]) : this.fb.array([]),
      promoterTitleFrom: ['Not at all likely', [Validators.required]],
      promoterTitleTo: ['Extremely likely', [Validators.required]],
      fileLocation: [""],
    })
  }

  firstoption() {
    this.fb.array([{
      name: ["", [this.appSnackBarService.noWhitespaceValidator]]
    }
    ])
  }
  initializeOptions() {
    return this.fb.group({
      name: ["", [this.appSnackBarService.noWhitespaceValidator]]
    })
  }

  //Add options function for choice 
  public addOptions(i) {
    let selectedQues = this.questionForm.get('questions') as FormArray;
    let ansArray = selectedQues.at(i).get('options') as FormArray;
    ansArray.push(this.initializeOptions());
  }

  // Function to return new question in card 
  public addNewQuestion(): void {
    this.addQuestion = true;
  }

  public getEditFormData(data): void {
    this.questionDetails = data;
    if (data && data.questions && data.questions.length > 0) {
      data.questions.forEach((e, index: number) => {
        e.fileLocation = (e.image) ? e.image : '';
        this.getQuestionType(e.questionType);
        // this.uploadedFiles[index].push(e.uploadedData);
        if (e.uploadedData) {
          this.handleFileUpload(e.uploadedData, index);
        }
        if (e.questionType == 'choice') {
          e.options.forEach((element: any, optionIndex: number) => {
            this.addOptions(index);
          });
        }
      });
      setTimeout(() => {
        this.questionForm.patchValue(data);
      }, 2000);
    }
  }

  //Function to select question type in toggle button
  public getQuestionType(e) {
    this.questionFormat.forEach(element => {
      if (e === element.type) {
        let createQues = this.questionForm.get('questions') as FormArray;
        createQues.push(this.questionGroupForm(element.type));
        this.createdQuestion.emit(this.questionForm);
        this.uploadedFiles.push('');
        this.savedFiles.push('');
      }
    });
    let focuseId = document.getElementById("clickId");
    setTimeout(function () {
      focuseId.classList.remove('mat-focused')
    }, 100);
  }



  public handleFileUpload(event, index) {
    if (event && event.target && event.target.files.length > 0) {
      if (event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpg' || event.target.files[0].type === 'image/jpeg') {
        const file = event.target.files[0];
        let selectedQues = this.questionForm.get('questions') as FormArray;
        selectedQues.at(index).get('isFileUpload').setValue(file);
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          file['url'] = reader.result;
        };
        this.uploadedFiles[index] = file;
        this.savedFiles[index] = '';
      } else {
        this.appSnackBarService.showSnackbar('Only one image file allowed', 'error', "", 2000, 'top', 'end',);
      }
    } else {
      let selectedQues = this.questionForm.get('questions') as FormArray;
      selectedQues.at(index).get('isFileUpload').setValue(event);
      this.uploadedFiles[index] = '';
      this.savedFiles[index] = '';
      this.uploadedFiles[index] = event.name;
      this.savedFiles[index] = event.fileLocation;
    }
  }

  public removeFileUpload(qIndex: number): void {
    let selectedQues = this.questionForm.get('questions') as FormArray;
    selectedQues.at(qIndex).get('isFileUpload').setValue('');
    this.uploadedFiles[qIndex] = '';
    this.savedFiles[qIndex] = '';
    if (this.questionDetails && this.questionDetails.questions) {
      this.questionDetails.questions[qIndex].fileLocation = '';
    }
    this.fileUpload.get(qIndex).nativeElement.value = '';
  }

  // public onSubmit() {
  //   if (this.questionForm.valid) {
  //   } else {
  //     this.appSnackBarService.touchAllFields(this.questionForm);
  //     this.appSnackBarService.showSnackbar('Please fill the required fields', 'error', "", 2000, 'top', 'end',);
  //   }
  // }

  public deleteQuestion(i) {
    let selectedQues = this.questionForm.get('questions') as FormArray;
    selectedQues.removeAt(i);
    this.uploadedFiles.splice(i, 1);
    if (this.questionDetails && this.questionDetails.questions) {
      this.questionDetails.questions.splice(i, 1);
    }

  }

  public deleteOption(qIndex, optionIndex) {
    let selectedQues = this.questionForm.get('questions') as FormArray;
    let ansArray = selectedQues.at(qIndex).get('options') as FormArray;
    ansArray.removeAt(optionIndex);
  }

  public moveUploadedFile(previousIndex: number, currentIndex: number) {
    let previousIndexFile = this.uploadedFiles[previousIndex];
    let currentIndexFile = this.uploadedFiles[currentIndex];
    this.uploadedFiles[previousIndex] = currentIndexFile;
    this.uploadedFiles[currentIndex] = previousIndexFile;
    this.moveEditObject(previousIndex, currentIndex);
  }

  public moveEditObject(previousIndex: number, currentIndex: number) {
    let previousIndexFile = this.questionDetails.questions[previousIndex];
    let currentIndexFile = this.questionDetails.questions[currentIndex];
    this.questionDetails.questions[previousIndex] = currentIndexFile;
    this.questionDetails.questions[currentIndex] = previousIndexFile;
  }

  dragQuestion(event: CdkDragDrop<string[]>) {
    let selectedQues = this.questionForm.get('questions') as FormArray;
    moveItemInFormArray(selectedQues, event.previousIndex, event.currentIndex);
    this.moveUploadedFile(event.previousIndex, event.currentIndex);
  }

  drop(event: CdkDragDrop<string[]>, index: number) {
    let selectedQues = this.questionForm.get('questions') as FormArray;
    let ansArray = selectedQues.at(index).get('options') as FormArray;
    moveItemInFormArray(ansArray, event.previousIndex, event.currentIndex);
    // this.moveUploadedFile(event.previousIndex, event.currentIndex);
  }

  public dragUp(index) {
    if (index > 0) {
      let selectedQues = this.questionForm.get('questions') as FormArray;
      moveItemInFormArray(selectedQues, index, index - 1);
      this.moveUploadedFile(index, index - 1);
    }
  }

  public dragDown(index) {
    let selectedQues = this.questionForm.get('questions') as FormArray;
    moveItemInFormArray(selectedQues, index, index + 1);
    this.moveUploadedFile(index, index + 1);
  }

}

export function moveItemInFormArray(formArray: FormArray, fromIndex: number, toIndex: number): void {
  const dir = toIndex > fromIndex ? 1 : -1;

  const from = fromIndex;
  const to = toIndex;

  const temp = formArray.at(from);
  for (let i = from; i * dir < to * dir; i = i + dir) {
    const current = formArray.at(i + dir);
    formArray.setControl(i, current);
  }
  formArray.setControl(to, temp);
}
